import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as lodash from 'lodash'
import { EntityTagsResponse } from './model'
import * as reducer from './reducer'
import * as state from './state'

export const entityTagState = createFeatureSelector<state.State>('entityTags')

export const isEntityTagsLoaded = createSelector(entityTagState, (entityTags) => entityTags.isLoaded)

export const selectAllEntityTags = createSelector(entityTagState, reducer.selectAll)

export const selectEntityTypeTags = (type: string) =>
  createSelector(selectAllEntityTags, (items: EntityTagsResponse[]) => {
    const tags = items.filter((item) => item.entity_type === type).map((item) => item.tags || [])
    return lodash.uniq(lodash.flatten(tags))
  })

export const selectTagsEntity = (type: string, id: string) =>
  createSelector(selectAllEntityTags, (items: EntityTagsResponse[]) =>
    items.find((item) => item.entity_type === type && item.entity_pkey === id)
  )

export const selectEntityTags = (type: string, id: string) =>
  createSelector(selectTagsEntity(type, id), (entity) => (entity ? entity.tags || [] : []))
